import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-spacetype-edit-modal',
  templateUrl: './spacetype-edit-modal.component.html',
  styleUrls: ['./spacetype-edit-modal.component.css']
})
export class SpacetypeEditModalComponent implements OnInit {
  @Input() spaceType: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveSpaceType(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
